export const phoneInternational = "+1-888-733-9757"
export const phoneFormatted = "1 888 733 9757"
export const phoneText = "1 888 REDWRKS"
